import '../../../App.css';

import imgBackAbout from "../../../img/coordenadorJesus.jpg";

const EquipeJesus = () => {
    return (
        <div className="container-fluid about bg-light pt-5">
            <div className="container">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.2s">
                        <div className="about-img pb-5 ps-5">
                            <img src={imgBackAbout} className="img-fluid rounded w-100" style={{ objectFit: 'cover', height: 400 }} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.4s">
                        <div className="section-title text-start mb-4">
                            <h4 className="sub-title pe-3 mb-1">Coordenação</h4>
                            <h1 className="display-3 mb-2">Nosso coordenador</h1>
                            <div>
                                <p className="mb-4">
                                    Na UTI Neonatal, cada gesto importa.
                                    <br />Trabalhamos com dedicação, técnica e cuidado, mas reconhecemos que nossa verdadeira direção vem de Jesus Cristo, o coordenador maior desta equipe.
                                    <br />Ele não veste jaleco, mas está presente em cada decisão, em cada vida que cuidamos.
                                    <br />Sua sabedoria nos guia nos momentos difíceis, Sua paz sustenta nossos corações nas urgências, e Seu amor nos inspira a servir com compaixão.
                                    <br />Sob a liderança de Cristo, nosso trabalho ganha propósito e nossa equipe caminha unida, com fé, esperança e amor.</p>
                                <p><i>"Deixem vir a mim as crianças e não as impeçam; pois o Reino dos céus
                                    pertence aos que são semelhantes a elas"</i> - Mateus 19:14</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}
export default EquipeJesus;
